(function () {
  "use strict";

  angular
    .module("alk.companyAdmin")
    .controller("addGroupsController", addGroupsController);

  addGroupsController.$inject = [
    "$q",
    "$http",
    "UserProvider",
    "_",
    "alkModalService",
    "$translate",
    "$scope",
    "$timeout",
    "$state",
    "modalData",
    "$uibModalInstance"
  ];
  function addGroupsController($q, $http, UserProvider, _, alkModalService, $translate, $scope, $timeout, $state, modalData, $uibModalInstance) {
    var vm = this;
    vm.filteredItems = [];
    vm.shownItems = [];

    vm.selectedVehicleGroups = angular.copy(modalData.selectedVehicleGroups);
    vm.selectedDriverGroups = angular.copy(modalData.selectedDriverGroups);
    vm.isVehicle = modalData.isVehicle;

    if (vm.isVehicle) {
      vm.groupList = angular.copy(modalData.allVehicleGroups);
      vm.shownItems = vm.groupList;
    } else {
      vm.groupList = angular.copy(modalData.allDriverGroups);
      vm.shownItems = vm.groupList;
    }

    init();

    function init() {
      vm.ids = [];
      for (var group of vm.groupList) {
        if (vm.isVehicle) {
          if (_.any(vm.selectedVehicleGroups, function(userGroup) {
            return userGroup.groupId === group.id;
          })) {
            group.checked = true;
          }
        } else {
          if (_.any(vm.selectedDriverGroups, function(userGroup) {
            return userGroup.groupId === group.id;
          })) {
            group.checked = true;
          }
        }
      }
      var allIds = vm.groupList.map(c => c.id);
      //vm.ids = allIds;
    }
    vm.selectAll = function() {
      for (let group of vm.shownItems) {
        group.checked = true;
      }
      vm.ids = vm.shownItems.map(c => c.id);
    };

    vm.selectNone = function() {
      for (let group of vm.groupList) {
        group.checked = false;
      }
      vm.ids = [];
    };
    vm.isUserAssignedToGroup = function(group) {
      if (vm.isVehicle) {
        return _.any(vm.selectedVehicleGroups, function(userGroup) { return userGroup.groupId === group.id; });
      }
      else {
        return _.any(vm.selectedDriverGroups, function(userGroup) { return userGroup.groupId === group.id; });
      }
    };

    vm.ok = function() {
      var groups = [];
      if (vm.isVehicle) {
        for (let group of vm.groupList) {
          if (group.checked) {
            groups.push({
              groupId: group.id,
              groupName: group.name
            });
          }
        }
      } else {
        for (let group of vm.groupList) {
          if (group.checked) {
            groups.push({
              groupId: group.id,
              groupName: group.name
            });
          }
        }
      }
      $uibModalInstance.close({
        groups: groups
      });

    };

    vm.cancel = function() {
      $uibModalInstance.dismiss();
    };
    vm.filterItems = function(filter) {
      // whenever filtering the list of units, reset the selected items
      if (!filter) {
        vm.filteredItems = vm.groupList;
      }else {
        let filterUpperCase = filter.toUpperCase();
        vm.filteredItems = vm.groupList.filter(c => c.name != null && c.name.toUpperCase().indexOf(filterUpperCase) != -1);
      }
      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
      vm.shownItems = vm.filteredItems;
    };
  }
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/addGroups.controller.js